<template>
  <div class="bg-repeat fullscreen">
    <div class="critical-box">
      <div class="logo">
        <img v-if="brandImage" :src="brandImage" alt="">
      </div>
      <div class="title">
        <span>{{ errorMessage }}</span>
      </div>
      <div class="content">
        <!--eslint-disable-next-line-->
        <p v-html="message" />
        <p class="return">
          <a href="/">{{ returnText }}</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { loadDynamicCss } from '@/utils/tool'

export default {
  name: 'Critical',
  data() {
    return {
      lang: this.$store.state.user.language,
      message: 'The page you are looking for might have some problem, please return and try again.'
    }
  },
  computed: {
    // brand API 失敗時 brandInfo 為 null
    brandImage() {
      const brandInfo = this.$store.getters.brandInfo
      return brandInfo && brandInfo.image
    },
    errorMessage() {
      switch (this.lang) {
        case 'tw':
          return '無法連線'
        case 'jp':
          return 'ただいまメンテナンス中です'
        default:
          return 'SOMETHING ERROR!'
      }
    },
    returnText() {
      switch (this.lang) {
        case 'tw':
          return '返回'
        case 'jp':
          return '戻る'
        default:
          return 'Return'
      }
    }
  },
  created() {
    loadDynamicCss()
  },
  mounted() {
    if (this.$store.getters.errorMessage) {
      this.message = this.$store.getters.errorMessage
      this.$store.commit('SET_ERROR_MESSAGE', null)
    }
  },
  methods: {

  }
}
</script>

<style scoped>
.fullscreen{
  width: 100%;
  height: 100vh;
}
</style>
